var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgVideoPlayIcon = function SvgVideoPlayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10441"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-play",
    d: "M9.516 7.575v24.848a.64.64 0 00.958.59l19.7-12.424a.7.7 0 000-1.171l-19.7-12.425a.634.634 0 00-.958.582z",
    fill: "#fff"
  }))));
};
export default SvgVideoPlayIcon;